module.exports = __webpack_public_path__ + "static/media/carousel_04.61fbbc71.gif";